import React from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid } from '@mui/material';

const EshopInfoStep = ({ eshopData, setEshopData, scraperConfig, setScraperConfig, eshop }) => {
    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    label="E-shop ID"
                    value={eshopData.eshop_id}
                    onChange={(e) => setEshopData({ ...eshopData, eshop_id: e.target.value })}
                    disabled={!!eshop} // Disable if editing existing e-shop (when eshop data is loaded)
                    helperText="Unique identifier for the e-shop"
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    label="Name"
                    value={eshopData.name}
                    onChange={(e) => setEshopData({ ...eshopData, name: e.target.value })}
                    helperText="Display name for the e-shop"
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    label="Base URL"
                    value={eshopData.base_url}
                    onChange={(e) => setEshopData({ ...eshopData, base_url: e.target.value })}
                    helperText="The main URL of the e-shop"
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    label="Main URL"
                    value={scraperConfig.url || (eshop?.config_json?.url || '')}
                    onChange={(e) => setScraperConfig({ ...scraperConfig, url: e.target.value })}
                    helperText="Main URL for the e-shop (optional, will use base URL if not provided)"
                />
            </Grid>
            <Grid item xs={12}>
                <FormControl fullWidth>
                    <InputLabel>Status</InputLabel>
                    <Select
                        value={eshopData.status}
                        onChange={(e) => setEshopData({ ...eshopData, status: e.target.value })}
                    >
                        <MenuItem value="active">Active</MenuItem>
                        <MenuItem value="inactive">Inactive</MenuItem>
                        <MenuItem value="error">Error</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12}>
                <FormControl fullWidth>
                    <InputLabel>Currency</InputLabel>
                    <Select
                        value={eshopData.currency || 'CZK'}
                        onChange={(e) => setEshopData({ ...eshopData, currency: e.target.value })}
                    >
                        <MenuItem value="CZK">CZK (Czech Koruna)</MenuItem>
                        <MenuItem value="EUR">EUR (Euro)</MenuItem>
                        <MenuItem value="USD">USD (US Dollar)</MenuItem>
                        <MenuItem value="GBP">GBP (British Pound)</MenuItem>
                        <MenuItem value="HUF">HUF (Hungarian Forint)</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    );
};

export default EshopInfoStep;